var map = {
	"./csharp.js": "EiXA",
	"./cswap/csharp.js": "iQFD",
	"./cswap/golang.js": "M62i",
	"./cswap/html.js": "+fEh",
	"./cswap/java.js": "GVhv",
	"./cswap/nodejs.js": "iyZf",
	"./cswap/php.js": "TTBR",
	"./cswap/python.js": "4a2j",
	"./cswap/shell.js": "Eo63",
	"./generate.js": "BxwQ",
	"./golang.js": "dsQw",
	"./html.js": "eXbW",
	"./java.js": "80Bj",
	"./nodejs.js": "y8sB",
	"./php.js": "4jl5",
	"./python.js": "yMq5",
	"./shell.js": "45yt",
	"./spot/csharp.js": "INcn",
	"./spot/golang.js": "y0aS",
	"./spot/html.js": "5KyA",
	"./spot/java.js": "zJn2",
	"./spot/nodejs.js": "qxtL",
	"./spot/php.js": "252X",
	"./spot/python.js": "bTzu",
	"./spot/shell.js": "bfXa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gVVV";


//////////////////
// WEBPACK FOOTER
// ./src/utils/codeWs ^\.\/.*\.js$
// module id = gVVV
// module chunks = 3